import React, { useEffect } from "react";
import { Tab } from "semantic-ui-react";

// UX
import ReviewVisit, { ReviewVisitProps } from "./ReviewVisit";
import ReviewEx, { ReviewExProps } from "./ReviewEx";
import ReviewTp, { ReviewTpProps } from "./ReviewTp";

// Types
type HistoryReviewTabProps = {
  selectedHistoryVisitId?: number;
  historyReviewSubTab?: string;
  anestheticOptions?: any[];
} & ReviewVisitProps &
  ReviewExProps &
  ReviewTpProps;

const HistoryReviewTab = (props: HistoryReviewTabProps) => {
  //props.openClinicalFindingsMenu
  //
  // <Icon name="plus" color="green" style={{ marginRight: "10px" }}/>
  //
  // console.log("HistoryReviewTab props:", props)
  useEffect(() => {
    if (props.selectedHistoryVisitId === null && props.historyReviewVisitData.length === 0) {
      props.handleGetHistoryVisit();
    }

    // #props.handleEvent({ message: "handleGetHistoryEx" });
    // #props.handleEvent({ message: "handleGetHistoryTp" });
  }, []);

  /* Menu, Option */
  const setActiveTab = (e: any, { activeIndex }: any) => {
    console.log("tab active ", activeIndex);
    if (activeIndex >= 0 && activeIndex <= 2) {
      props.onEvent({ message: "ChangeHistoryReviewSubTab", params: { historyReviewSubTab: activeIndex } });
    }
    // #props.setState({ activeTab: activeIndex });
  };

  const handleChangeDate = (key: "start" | "end") => (date: string) => {
    const keys = {
      start: ["visitStartDate", "exStartDate", "tpStartDate"],
      end: ["visitEndDate", "exEndDate", "tpEndDate"],
    }[key];

    const historyDate = { ...(props.historyDate || {}), ...Object.fromEntries(keys.map((key) => [key, date])) };

    props.setProp("historyDate", historyDate);
  };

  const handleSearchHistory = ()=> {
    props.handleGetHistoryVisit();
    props.handleGetHistoryEx();
    props.handleGetHistoryTp();
  }

  return (
    <Tab
      menu={{ color: "green", secondary: true, pointing: true }}
      onTabChange={setActiveTab}
      activeIndex={props.historyReviewSubTab}
      panes={[
        {
          menuItem: "Visit",
          render: () => (
            <Tab.Pane style={{ backgroundColor: "#f5f5f5", marginTop: "-10px", border: "none" }}>
              <ReviewVisit
                onEvent={props.onEvent}
                setProp={props.setProp}
                // data
                patientFamilyTPList={props.patientFamilyTPList}
                columnsHistoryVisit={props.columnsHistoryVisit}
                historyReviewVisitData={props.historyReviewVisitData}
                patientId={props.patientId}
                tableHeight={props.tableHeight}
                languageUX={props.languageUX}
                historyDate={props.historyDate}
                // filter
                doctorFilterList={props.doctorFilterList}
                clinicFilterList={props.clinicFilterList}
                openModalFilter={props.openModalFilter}
                openModalFilterClinic={props.openModalFilterClinic}
                // callback
                handleGetHistoryVisit={handleSearchHistory}
                handleOnFocusFindingsRowVisit={props.handleOnFocusFindingsRowVisit}
                onChangeDate={handleChangeDate}
              />
            </Tab.Pane>
          ),
        },
        {
          menuItem: "Examination",
          render: () => (
            <Tab.Pane style={{ backgroundColor: "#f5f5f5", marginTop: "-10px", border: "none" }}>
              <ReviewEx
                onEvent={props.onEvent}
                setProp={props.setProp}
                // data
                columnsHistoryEx={props.columnsHistoryEx}
                historyReviewExData={props.historyReviewExData}
                patientId={props.patientId}
                tableHeight={props.tableHeight}
                languageUX={props.languageUX}
                historyDate={props.historyDate}
                organItems={props.organItems}
                showDrawingChecked={props.showDrawingChecked}
                // filter
                doctorFilterListEx={props.doctorFilterListEx}
                clinicFilterListEx={props.clinicFilterListEx}
                locationFilterList={props.locationFilterList}
                clinicalFindingFilterList={props.clinicalFindingFilterList}
                openModalDoctorExFilter={props.openModalDoctorExFilter}
                openModalFilterClinicEx={props.openModalFilterClinicEx}
                openModalFilterLocation={props.openModalFilterLocation}
                openModalFilterClinicalFinding={props.openModalFilterClinicalFinding}
                // callback
                handleGetHistoryEx={handleSearchHistory}
                handleOnFocusFindingsRowEx={props.handleOnFocusFindingsRowEx}
                onChangeDate={handleChangeDate}
              />
            </Tab.Pane>
          ),
        },
        {
          menuItem: "Treatment plan",
          render: () => (
            <Tab.Pane style={{ backgroundColor: "#f5f5f5", marginTop: "-10px", border: "none" }}>
              <ReviewTp
                onEvent={props.onEvent}
                setProp={props.setProp}
                // data
                columnsHistoryTp={props.columnsHistoryTp}
                historyReviewTpData={props.historyReviewTpData}
                patientId={props.patientId}
                tableHeight={props.tableHeight}
                languageUX={props.languageUX}
                historyDate={props.historyDate}
                organItems={props.organItems}
                treatmentRecord={props.treatmentRecord}
                hideTreatmentForm={props.hideTreatmentForm}
                selectedHistoryTp={props.selectedHistoryTp}
                // filter
                doctorFilterListTp={props.doctorFilterListTp}
                clinicFilterListTp={props.clinicFilterListTp}
                locationFilterListTp={props.locationFilterListTp}
                treatmentFilterListTp={props.treatmentFilterListTp}
                treatmentCodeFilterListTp={props.treatmentCodeFilterListTp}
                statusFilterList={props.statusFilterList}
                openModalDoctorTpFilter={props.openModalDoctorTpFilter}
                openModalFilterClinicTp={props.openModalFilterClinicTp}
                openModalFilterLocationTp={props.openModalFilterLocationTp}
                openModalFilterTreatmentTp={props.openModalFilterTreatmentTp}
                openModalFilterTreatmentCodeTp={props.openModalFilterTreatmentCodeTp}
                openModalFilterStatus={props.openModalFilterStatus}
                // callback
                handleGetHistoryTp={handleSearchHistory}
                handleOnFocusFindingsRowTp={props.handleOnFocusFindingsRowTp}
                handleCloseTreatmentRecord={props.handleCloseTreatmentRecord}
                onChangeDate={handleChangeDate}
                // SubTreatmentRercord Issue 67238
                anestheticOptions={props.anestheticOptions}

              />
            </Tab.Pane>
          ),
        },
      ]}
    />
  );
};

HistoryReviewTab.displayName = "HistoryReviewTab";

export default React.memo(HistoryReviewTab);
